module.exports = __webpack_public_path__ + "static/media/o2.fc4d87bf.png";